import styled from "styled-components";
import { Row } from 'reactstrap';
import { X } from "react-bootstrap-icons";

export const SiteMessage = styled.div`
    font-family: Lato-Bold;
    text-transform: uppercase;
    text-align:center;
    background-color: var(--main-orange-color);
    color: #FFF;
    border-top: 2px solid white;
    padding: 1.5em 2em 1.5em 2em;
`;

export const Header = styled.h2`
    font-size: 2rem;
    color: var(--main-teal-color);
    font-family: Lato-Bold;
    padding: 30px 0px 30px 0px;
`;
export const ListContainer = styled.ul`
    padding: 0;
`;
export const ListItem = styled.li`
    font-size: 0.8rem;
    line-height: 2em;

    :before {
        display:inline-block;
        vertical-align:middle;
        width:6px;
        height:6px;
        transform: rotate(-45deg);
        margin-right:10px;
        content:' ';
        background-color: var(--main-teal-color);
    }
`;
export const Toast = styled.div`
    position:absolute;
    color: var(--main-teal-color);
    top:100;
    background-color: #fff;
    margin:10px;
    padding:10px;
    animation-delay: 5s;
    animation-name: fadeOut;
    animation-duration: 1s;
    animation-fill-mode: forwards;
        @keyframes fadeOut {
            100% { opacity: 0;}
            0% { opacity: 1;}
        }
`;
export const DashboardIcon = styled.img`
   width: 10%;
   padding:10px;
   @media (max-width: 1100px) {
        display:none;
   }
`;
export const RowContainer = styled.div`
   display: flex; 
   justify-content:center;
   align-items: center
`;
export const ResponsiveRow = styled(Row)`
    @media only screen and (max-width: 500px) {
        list-style-type: none;
        display: list-item;
    }
`;

export const Modal = styled.div`
   display: block;
   position: fixed;
   z-index: 3;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   background-color: rgb(0,0,0);
   background-color: rgba(0,0,0,0.4);
`;
export const ModalBody = styled.div`
   display:flex;
   justify-content:center;
   align-items:center;
`;
export const ModalMessage = styled.p`
   padding: 3em;
   background-color: #fff;
`;
export const CloseIcon = styled(X)`
   color:#FFF;
   font-size: 2em;
   cursor:pointer;
`;